import {StyleSheet} from 'react-native';

export default StyleSheet.create({
  root: {},
  disc: {
    backgroundColor: 'rgba(255, 108, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 50,
  },
  selected: {
    borderWidth: 4,
    borderColor: '#181617',
  },
  dealer: {
    backgroundColor: 'rgba(41, 153, 118, 0.5)',
  },
  text: {
    fontWeight: '600',
    color: 'white',
  },
});
